import axios from 'axios';

import { quickpackApi } from '~/services/api';

import { HTTP_BARCODE_RESPONSE_SCHEMA } from '../schemata/barcode.schema';
import { type HttpBarcodeResponse } from '../types/barcode.type';

/**
 * Resolves a scanned barcode value to its type and associated content.
 * Returns `null` when the value has no associated object, or when the
 * barcode type is not yet supported by the client.
 */
export const getBarcode = async (value: string): Promise<HttpBarcodeResponse | null> => {
  try {
    const response = await quickpackApi.request<unknown>({
      method: 'GET',
      url: `/devices/barcodes/${encodeURIComponent(value)}`,
    });

    const parsed = HTTP_BARCODE_RESPONSE_SCHEMA.safeParse(response.data);
    return parsed.success ? parsed.data : null;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) return null;

    throw error;
  }
};
